// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c78e9113","455":"c80e08cc"}[chunkId] + ".chunk.js";
};